import { useEffect, useState } from "react";
import "./CookieNotice.css";

const CONSENT_KEY = "portfolio_usage_notice_accepted";

export default function CookieNotice() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(CONSENT_KEY) === "true";
    if (!accepted) {
      const timer = window.setTimeout(() => setOpen(true), 500);
      return () => window.clearTimeout(timer);
    }
  }, []);

  const acceptNotice = () => {
    localStorage.setItem(CONSENT_KEY, "true");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <aside
      className="cookie-notice"
      role="dialog"
      aria-live="polite"
      aria-label="Usage notice"
    >
      <div className="cookie-notice__panel">
        <p className="cookie-notice__eyebrow">Usage Notice</p>

        <h2>We use basic analytics to improve this site.</h2>

        <p className="cookie-notice__copy">
          This portfolio tracks simple activity like clicks, scrolls, time
          active, and card interactions to improve the experience. We also use
          Google Analytics for aggregate traffic insights. No personal data is
          sold or shared with third parties for advertising.
        </p>

        <button
          className="cookie-notice__button"
          type="button"
          onClick={acceptNotice}
        >
          Got it
        </button>
      </div>
    </aside>
  );
}
